import { apiBaseUrl } from "./config"
import { getBaseHeader }          from "./utils"
import { genericFetch } from "./common-service"
import RegulatoryInformation from "../../model/regulatory-information"

const REGULATORYINFORMATION = `regulatory_information`;

export function getInformation(): Promise<RegulatoryInformation> {
	const url = `${apiBaseUrl}/${REGULATORYINFORMATION}`;
	const init = { headers: getBaseHeader(true) }
	return genericFetch<RegulatoryInformation>(url, init)
}

export const createOrUpdateRegulatoryInformation = async (information) => {
    const URL = `${apiBaseUrl}/${REGULATORYINFORMATION}`;    
    const init = {
		body: JSON.stringify({"information": information}),
		headers: {
			...getBaseHeader(),
			"Content-Type": "application/json"
		},
		method: "POST"
	}
	return genericFetch(URL, init)
};



// WEBPACK FOOTER //
// ./src/service/sfp/regulatoryInformationService.ts